
import { defineComponent, onMounted, ref, watch } from 'vue';
import numeral from 'numeral';

import useInventarios from '../composables/useInventarios';
import useProductos from '../composables/useProductos';
import { descripcionConcepto } from '../utils/kardexConceptos';

export default defineComponent({
    setup() {
        const { obtenerKardexIndividual } = useInventarios();
        const { obtenerProductosParaLaVentaCompra } = useProductos();

        const productos              = ref<any[]>([]);
        const idProductoSeleccionado = ref<string>('');
        const idProductoStockActual  = ref<number>(0);
        const movimientos            = ref<any[]>([]);
        const resumen                = ref<any>(null);
        const totalItems             = ref(0);
        const loading                = ref(false);
        const anioFiltro             = ref<number>(0);
        const mesFiltro              = ref<number>(0);

        const anioActual = new Date().getFullYear();
        const anios = Array.from({ length: anioActual - 2019 }, (_, i) => anioActual - i);

        const meses = [
            { valor: 1,  nombre: 'Enero' },
            { valor: 2,  nombre: 'Febrero' },
            { valor: 3,  nombre: 'Marzo' },
            { valor: 4,  nombre: 'Abril' },
            { valor: 5,  nombre: 'Mayo' },
            { valor: 6,  nombre: 'Junio' },
            { valor: 7,  nombre: 'Julio' },
            { valor: 8,  nombre: 'Agosto' },
            { valor: 9,  nombre: 'Septiembre' },
            { valor: 10, nombre: 'Octubre' },
            { valor: 11, nombre: 'Noviembre' },
            { valor: 12, nombre: 'Diciembre' },
        ];

        const serverOptions = ref({
            page: 1,
            rowsPerPage: 50,
        });

        const headers = [
            { text: 'Fecha',           value: 'fecha',                 sortable: true },
            { text: 'Tipo',            value: 'tipo_movimiento',       sortable: true },
            { text: 'Concepto',        value: 'concepto',              sortable: true },
            { text: 'Cantidad',        value: 'movimiento',            sortable: true },
            { text: 'P. Costo Unit.',  value: 'precio_costo_unitario', sortable: true },
            { text: 'Costo Total',     value: 'costo_total',           sortable: true },
            { text: 'Saldo Unid.',     value: 'saldo_unidades',        sortable: true },
            { text: 'Saldo Valor',     value: 'saldo_valor',           sortable: true },
        ];

        onMounted(async () => {
            const resp = await obtenerProductosParaLaVentaCompra();
            if (resp.ok) productos.value = resp.data as unknown as any[];
        });

        const cargarMovimientos = async () => {
            if (!idProductoStockActual.value) return;
            loading.value = true;
            const resp = await obtenerKardexIndividual(
                idProductoStockActual.value,
                serverOptions.value.page,
                serverOptions.value.rowsPerPage,
                anioFiltro.value,
                mesFiltro.value,
            );
            loading.value = false;
            if (resp.ok) {
                movimientos.value = resp.data.movimientos;
                totalItems.value  = resp.data.total;
                resumen.value     = resp.data.resumen;
            }
        };

        // Cuando cambia página o filas por página
        watch(serverOptions, () => { cargarMovimientos(); }, { deep: true });

        const onProductoSeleccionado = async () => {
            if (!idProductoSeleccionado.value) return;
            const producto = productos.value.find(
                (p: any) => p.id_producto == idProductoSeleccionado.value
            );
            if (!producto) return;

            idProductoStockActual.value = producto.id_producto_stock;
            serverOptions.value.page    = 1;
            await cargarMovimientos();
        };

        const onFiltroFecha = async () => {
            // Si se borra el año, también limpiamos el mes
            if (anioFiltro.value === 0) mesFiltro.value = 0;
            serverOptions.value.page = 1;
            await cargarMovimientos();
        };

        return {
            productos,
            idProductoSeleccionado,
            idProductoStockActual,
            movimientos,
            resumen,
            totalItems,
            loading,
            serverOptions,
            anioFiltro,
            mesFiltro,
            anios,
            meses,
            headers,
            numeral,
            descripcionConcepto,
            onProductoSeleccionado,
            onFiltroFecha,
        };
    },
});
